import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReconciliationWorkspaceRoute } from '@/features/accounting-bank/reconciliation-workspace-route'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute(
  '/_authenticated/accounting/bank-accounts/$accountId/reconcile/$reconciliationId',
)({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank.view')) {
      throw redirect({ to: '/accounting/bank-accounts' })
    }
    if (!hasGrant(context.queryClient, 'accounting_reconciliation.view')) {
      throw redirect({ to: '/accounting/bank-accounts' })
    }
    if (!hasGrant(context.queryClient, 'accounting_account.view')) {
      throw redirect({ to: '/accounting/bank-accounts' })
    }
  },
  component: BankAccountReconciliationRoute,
})

function BankAccountReconciliationRoute() {
  const { accountId, reconciliationId } = Route.useParams()
  return (
    <ReconciliationWorkspaceRoute bankAccountId={accountId} reconciliationId={reconciliationId} />
  )
}
